import { createActions } from 'redux-actions';

const {
  deleteUserProfile,
  deleteUserProfileSuccess,
  deleteUserProfileFailure,
  getUserProfiles,
  getUserProfilesSuccess,
  getUserProfilesFailure,
  setActiveProfile,
  unsetActiveProfile,
  setProfileMonitoring,
  setProfileMonitoringSuccess,
} = createActions(
  'DELETE_USER_PROFILE',
  'DELETE_USER_PROFILE_SUCCESS',
  'DELETE_USER_PROFILE_FAILURE',
  'GET_USER_PROFILES',
  'GET_USER_PROFILES_SUCCESS',
  'GET_USER_PROFILES_FAILURE',
  'SET_ACTIVE_PROFILE',
  'UNSET_ACTIVE_PROFILE',
  'SET_PROFILE_MONITORING',
  'SET_PROFILE_MONITORING_SUCCESS'
);

export {
  deleteUserProfile,
  deleteUserProfileSuccess,
  deleteUserProfileFailure,
  getUserProfiles,
  getUserProfilesSuccess,
  getUserProfilesFailure,
  setActiveProfile,
  unsetActiveProfile,
  setProfileMonitoring,
  setProfileMonitoringSuccess,
};
